import React from 'react';
import DepositFrontDeskList from './components/DepositFrontDeskList2';

const DepositFrontDesk = () => (
  <React.Suspense fallback={<div>Loading...</div>}>
    <DepositFrontDeskList />
  </React.Suspense>
);

export default DepositFrontDesk;
